const monthNames = [
    'jan',
    'fev',
    'mar',
    'abr',
    'mai',
    'jun',
    'jul',
    'ago',
    'set',
    'out',
    'nov',
    'dez',
];
export const checkPeriodoPersonalizado = (periodo) => {
    const data_split = periodo.split(/[+\s]|%20+/); // separa o periodo em duas partes(separador: espaço em branco, '+' ou '%20')
    if (data_split.length < 2) { // se tiver um ou nenhum elemento, ele vai utilizar a data_ini como o periodo e data_fim como 31129999
        return null;
    }
    return {
        start: data_split[0],
        end: data_split[1],
    };
};
export const truncateDecimals = (valueRaw) => {
    const formatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 8,
    });
    if (valueRaw === '')
        return '';
    let value = valueRaw;
    if (typeof valueRaw === 'string')
        value = parseFloat(valueRaw.replace(',', '.'));
    return formatter.format(value);
};
export const roundDecimal = (valueRaw, numCasas) => {
    if (valueRaw === '')
        return '';
    let value = valueRaw;
    if (typeof valueRaw === 'string')
        value = parseFloat(valueRaw.replace(',', '.'));
    const valueAux = (Math.round((value + 0.00001) * 100) / 100).toFixed(numCasas);
    return valueAux
        .toString()
        .replace('.', ',')
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
};
export const extendedNumberFormatter2 = (valueString, prefixo) => {
    if (valueString === '')
        return '';
    const usedPrefix = typeof prefixo === 'undefined' ? prefixo : '';
    const value = parseFloat(valueString);
    let divisor = 1;
    let sufixo = '';
    let numCasas = 2;
    if (value >= 999999999) {
        divisor = 1000000000;
        sufixo = ' bi';
    }
    else if (value >= 999999) {
        divisor = 1000000;
        sufixo = ' mi';
    }
    else if (value >= 999) {
        divisor = 1000;
        sufixo = ' mil';
    }
    else {
        numCasas = 0;
    }
    const dividido = value / divisor;
    return usedPrefix + roundDecimal(dividido.toString(), numCasas) + sufixo;
};
export const extendedNumberFormatter = (numToFormat, digits, prefix) => {
    let num = numToFormat;
    let negative = false;
    if (numToFormat < 0) {
        num *= -1;
        negative = true;
    }
    const lookup = [
        { value: 1, symbol: '' },
        { value: 1e3, symbol: ' k' },
        { value: 1e6, symbol: ' mi' },
        { value: 1e9, symbol: ' bi' },
        { value: 1e12, symbol: ' tr' },
        { value: 1e15, symbol: ' qd' },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    const item = lookup
        .slice()
        .reverse()
        .find((newItem) => num >= newItem.value);
    const usePrefix = `${negative ? '-' : ''}${prefix !== null && prefix !== void 0 ? prefix : ''}`;
    return item
        ? usePrefix +
            (num / item.value).toFixed(digits).replace(rx, '$1').replace('.', ',') +
            item.symbol
        : '0';
};
export var FormatTypes;
(function (FormatTypes) {
    FormatTypes["percentage"] = "percentage";
    FormatTypes["decimals"] = "decimals";
    FormatTypes["no_decimals"] = "no_decimals";
    FormatTypes["monetary_extense"] = "monetary_extense";
    FormatTypes["monetary"] = "monetary";
    FormatTypes["monetary_no_space"] = "monetary_no_space";
    FormatTypes["extense"] = "extense";
    FormatTypes["millions"] = "millions";
    FormatTypes["month_year"] = "month_year";
    FormatTypes["month_year_capitilized"] = "month_year_capitilized";
    FormatTypes["text"] = "text";
    FormatTypes["truncate"] = "truncate";
})(FormatTypes || (FormatTypes = {}));
export const helperFormat = (value, type, digits, moneyPrefix) => {
    let content = '-';
    if (value === undefined || value === 'nd' || value === '' || Number.isNaN(value))
        return content;
    switch (type) {
        case 'percentage':
            content = `${roundDecimal(value, digits !== null && digits !== void 0 ? digits : 2)}%`;
            break;
        case 'decimals':
            content = roundDecimal(value, digits !== null && digits !== void 0 ? digits : 2);
            break;
        case 'no_decimals':
            content = roundDecimal(value, digits !== null && digits !== void 0 ? digits : 0);
            break;
        case 'monetary_extense':
            content = extendedNumberFormatter(value, digits !== null && digits !== void 0 ? digits : 2, moneyPrefix !== null && moneyPrefix !== void 0 ? moneyPrefix : 'R$');
            break;
        case 'monetary':
            content = `${moneyPrefix !== null && moneyPrefix !== void 0 ? moneyPrefix : 'R$'} ${roundDecimal(value, digits !== null && digits !== void 0 ? digits : 2)}`;
            break;
        case 'monetary_no_space':
            content = `${moneyPrefix !== null && moneyPrefix !== void 0 ? moneyPrefix : 'R$'}${roundDecimal(value, digits !== null && digits !== void 0 ? digits : 2)}`;
            break;
        case 'extense':
            content = extendedNumberFormatter(value);
            break;
        case 'millions':
            content = roundDecimal(value, digits !== null && digits !== void 0 ? digits : 0);
            break;
        case 'month_year':
            content = `(${monthNames[parseFloat(value.substring(6, 8)) - 1]}/${value.substring(1, 5)})`;
            break;
        case 'month_year_capitilized': {
            const monthIndex = value.substring(5, 7) - 1;
            const month = monthNames[monthIndex];
            const capitalizedMonth = month[0].toUpperCase() + month.slice(1);
            content = `${capitalizedMonth}/${value.substring(0, 4)}`;
            break;
        }
        case 'text':
            content = value;
            break;
        case 'truncate':
            content = truncateDecimals(value);
            break;
        default:
            content = value;
            break;
    }
    return content;
};
export const limitToModulus = (num, limit) => {
    if (typeof num === 'string')
        return num;
    const sign = Math.sign(num);
    if (sign * num > limit)
        return sign * limit;
    return num;
};
export function groupAndSumByProperties(data, classKey, subclassKey, sumKeys) {
    // Group objects by class and subclass
    const groups = data === null || data === void 0 ? void 0 : data.reduce((acc, curr) => {
        const classValue = curr[classKey];
        const subclassValue = curr[subclassKey];
        const group = acc.findIndex((g) => g.class === classValue && g.subclass === subclassValue);
        if (group !== -1) {
            // If the group already exists, add the numeric properties to the subtotal
            sumKeys === null || sumKeys === void 0 ? void 0 : sumKeys.forEach((key) => {
                acc[group].subtotal[key] = (acc[group].subtotal[key] || 0) + curr[key];
            });
            acc[group].values.push(curr);
        }
        else {
            const subtotal = {};
            sumKeys === null || sumKeys === void 0 ? void 0 : sumKeys.forEach((key) => {
                subtotal[key] = curr[key];
            });
            acc.push({
                class: classValue,
                subclass: subclassValue,
                subtotal,
                values: [curr],
            });
        }
        return acc;
    }, []);
    // Group objects by class and compute the subtotal for each class
    const classGroups = groups === null || groups === void 0 ? void 0 : groups.reduce((acc, curr) => {
        const classValue = curr.class;
        const group = acc.findIndex((g) => g.class === classValue);
        if (group !== -1) {
            // If the group already exists, add the numeric properties to the subtotal
            sumKeys === null || sumKeys === void 0 ? void 0 : sumKeys.forEach((key) => {
                acc[group].subtotal[key] = (acc[group].subtotal[key] || 0) + curr.subtotal[key];
            });
            acc[group].subclasses.push({
                subclass: curr.subclass,
                subtotal: curr.subtotal,
                values: curr.values,
            });
        }
        else {
            // If the group doesn't exist, create a new group with a subtotal object
            acc.push({
                class: classValue,
                subtotal: JSON.parse(JSON.stringify((curr.subtotal))),
                subclasses: [{ subclass: curr.subclass, subtotal: curr.subtotal, values: curr.values }],
            });
        }
        return acc;
    }, []);
    return classGroups;
}
export function sumByProperties(data, sumKeys) {
    // Group objects by class and subclass
    const groups = data === null || data === void 0 ? void 0 : data.reduce((acc, curr) => {
        // If the group already exists, add the numeric properties to the subtotal
        sumKeys === null || sumKeys === void 0 ? void 0 : sumKeys.forEach((key) => {
            acc[key] = (acc[key] || 0) + curr[key];
        });
        return acc;
    }, {});
    return groups;
}
export const auxFormatPercent = (value) => {
    if (value === '')
        return value;
    return typeof value === 'number' ? value * 100 : Number(value) * 100;
};
function verificarCarteira(selectedBenchmarks, benchmarksLiberados) {
    for (let i = 0; i < selectedBenchmarks.length; i++) {
        if (!(benchmarksLiberados === null || benchmarksLiberados === void 0 ? void 0 : benchmarksLiberados.includes(selectedBenchmarks[i]))) {
            return true;
        }
    }
    return false;
}
export function selecionarBenchmarks(loadedCarteiraList, carteiraList, carteira, dispatchPDF, selectedBenchmarks, nomeAba, dispatchSelectedBenchmarks) {
    var _a, _b, _c, _d, _e;
    if (loadedCarteiraList && carteiraList && carteiraList[0] && carteira && !dispatchPDF) {
        if (!selectedBenchmarks || verificarCarteira(selectedBenchmarks, (_a = carteiraList.filter((item) => item.nome_portfolio.toUpperCase() === carteira.toUpperCase())[0]) === null || _a === void 0 ? void 0 : _a.CV_bench_liberado)) {
            if (nomeAba === 'resumoCart') {
                dispatchSelectedBenchmarks((_c = (_b = carteiraList.filter((item) => item.nome_portfolio.toUpperCase() === carteira.toUpperCase())[0]) === null || _b === void 0 ? void 0 : _b.CV_bench_carteira1) !== null && _c !== void 0 ? _c : [], true);
            }
            else {
                dispatchSelectedBenchmarks((_e = (_d = carteiraList.filter((item) => item.nome_portfolio.toUpperCase() === carteira.toUpperCase())[0]) === null || _d === void 0 ? void 0 : _d.CV_bench_mes_a_mes) !== null && _e !== void 0 ? _e : [], true);
            }
        }
        else {
            dispatchSelectedBenchmarks(selectedBenchmarks ? selectedBenchmarks : [''], true);
        }
    }
}
export const compareDatesDDMMYYYY = (date1, date2) => {
    if (typeof date1 === 'number')
        date1 = date1.toString();
    if (typeof date2 === 'number')
        date2 = date2.toString();
    const parsedDate1 = parseDateDDMMYYYY(date1);
    const parsedDate2 = parseDateDDMMYYYY(date2);
    if (parsedDate1 < parsedDate2) {
        return -1;
    }
    else if (parsedDate1 > parsedDate2) {
        return 1;
    }
    else {
        return 0;
    }
};
export const parseDateDDMMYYYY = (date) => {
    const day = Number(date.slice(0, 2));
    const month = Number(date.slice(2, 4)) - 1;
    const year = Number(date.slice(4, 8));
    return new Date(year, month, day);
};
const rgbToHEX = ({ r, g, b }) => '#' + [r, g, b].map(x => {
    const hex = x.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}).join('');
export const hexToRGB = (hex) => {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : null;
};
//blend with white based on alpha, alpha=0.8 ~ 20% transparency
const alphaBlendWithWhite = (x, alpha) => {
    return Math.round((1 - alpha) * 255 + alpha * x);
};
export const hexToRGBA = (hex, alpha) => {
    const rgb = hexToRGB(hex);
    if (!rgb)
        return hex;
    return rgbToHEX({
        r: alphaBlendWithWhite(rgb.r, alpha),
        g: alphaBlendWithWhite(rgb.g, alpha),
        b: alphaBlendWithWhite(rgb.b, alpha),
    });
};
/**
 * Constrói uma data a partir de uma data e uma timezone
 * (se eu receber uma data em string com horário de SP, mas meu sistema está em São Francisco,
 * passo a data construída com a hora e passo a timezone de SP, recebendo o horário convertido para SF)
 */
export function changeTimezone(date, timezone) {
    const shiftedDate = new Date(date.toLocaleString('en-US', {
        timeZone: timezone
    }));
    const diff = date.getTime() - shiftedDate.getTime();
    return new Date(date.getTime() + diff); // needs to substract
}
/**
 * Verifica se o elemento é um array de strings
 * @param array Elemento
 * @returns Se é um array de strings
 */
export function checkIsArrayString(array) {
    return Array.isArray(array) && array.every((el) => typeof el === "string");
}
/**
 * Recebe colunas de uma tabela com o campo label e substitui pelos labels passados
 * @param columns Colunas da tabela
 * @param labels Array com os títulos de cada coluna
 * @returns colunas com os títulos alterados
 */
export function changeColumnsLabel(columns, labels) {
    return columns.map((col, index) => {
        var _a;
        return (Object.assign(Object.assign({}, col), { label: (_a = labels[index]) !== null && _a !== void 0 ? _a : col.label }));
    });
}
